/// <amd-module name="SuiteCommerce.FeaturedProduct.Common.DependencyProvider"/>
define("SuiteCommerce.FeaturedProduct.Common.DependencyProvider", ["require", "exports", "underscore", "Backbone.CachedModel"], function (require, exports, _, BackboneCachedModelModule) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BackboneCachedModel = void 0;
    exports.BackboneCachedModel = getDependency(BackboneCachedModelModule);
    function getDependency(module) {
        if (isTranspiledModule(module)) {
            return module[Object.keys(module)[0]];
        }
        return module;
    }
    function isTranspiledModule(module) {
        var moduleKeys = Object.keys(module);
        return !_.isFunction(module) && moduleKeys.length === 1;
    }
});
